import React from 'react';
import s from './GiftCards.module.scss';
import { useTranslation } from 'react-i18next';
import useGetGiftCardsBySalonId from 'sdk/hooks/salon/useGetGiftCardsBySalonId';
import { useParams } from 'react-router-dom';

interface GiftCard {
  id: number;
  denomination: number;
  color: string;
  valid_until: string;
  services: {
    name: string;
  };
}

const GiftCards: React.FC = () => {
    const { t } = useTranslation() as any;
    const { salonId } = useParams<{ salonId: string }>();
    const { data: giftCards, isLoading } = useGetGiftCardsBySalonId(salonId);

    if (isLoading) {
        return (
            <div className={s.container}>
                <div className={s.placeholder}>
                    <p>{t('Loading')}</p>
                </div>
            </div>
        );
    }

    if (!giftCards || giftCards.length === 0) {
        return (
            <div className={s.container}>
                <div className={s.placeholder}>
                    <p>{t('Gift cards coming soon')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={s.container}>
            <div className={s.giftCardsGrid}>
                {(giftCards as GiftCard[]).map((card: GiftCard) => (
                    <div key={card.id} className={s.giftCard} style={{ backgroundColor: card.color }}>
                        <div className={s.denomination}>${card.denomination}</div>
                        <div className={s.serviceInfo}>
                            <span className={s.serviceName}>{card.services?.name}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GiftCards;